/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export type ReceivedProps = Record<string, any>;

export const COMPANY_DETAIL_TABS = {
  REGISTRATION_INFO: { key: "registration_information", label: "登記情報" },
  GENERAL_MANAGEMENT_INFO: {
    key: "general_management_information",
    label: "総務管理情報",
  },
  CONTRACT: { key: "contract_information", label: "取引情報" },
};

const useCustomerDetail = (props: ReceivedProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeKey, setActiveKey] = useState(
    COMPANY_DETAIL_TABS.REGISTRATION_INFO.key,
  );
  const tabParams = searchParams.get("tab");
  const pageMode = searchParams.get("page_mode");
  const onChange = (key: string) => {
    setSearchParams(
      (prev) => {
        const isDisplayInNewTab = prev.get("isDisplayInNewTab");
        return {
          ...prev,
          ...(isDisplayInNewTab
            ? { isDisplayInNewTab: isDisplayInNewTab }
            : {}),
          tab: COMPANY_DETAIL_TABS.REGISTRATION_INFO.key,
          ...(pageMode ? { page_mode: pageMode } : {}),
        };
      },
      { replace: true },
    );
    setActiveKey(key);
  };

  useEffect(() => {
    if (!tabParams) {
      setSearchParams(
        (prev) => {
          const isDisplayInNewTab = prev.get("isDisplayInNewTab");
          return {
            ...prev,
            ...(isDisplayInNewTab
              ? { isDisplayInNewTab: isDisplayInNewTab }
              : {}),
            tab: COMPANY_DETAIL_TABS.REGISTRATION_INFO.key,
            ...(pageMode ? { page_mode: pageMode } : {}),
          };
        },
        { replace: true },
      );
      setActiveKey(COMPANY_DETAIL_TABS.REGISTRATION_INFO.key);
    } else {
      setActiveKey(tabParams);
    }
  }, [tabParams]);

  return {
    ...props,
    activeKey,
    onChange,
    isQuickView: props?.isQuickView,
    clientIdQuickView: props?.clientIdQuickView,
    handleCloseQuickView: props?.handleCloseQuickView,
    handleViewDetail: props?.handleViewDetail,
    handleViewEdit: props?.handleViewEdit,
  };
};

export type Props = ReturnType<typeof useCustomerDetail>;

export default useCustomerDetail;
